import apiTCEComunica from '../infra/apiTCEComunica'

const SolicitacaoService = {
    Consulta: async (cpf) => {
        return await apiTCEComunica.get(`/api/v1/Solicitacao/${cpf}`)
    },
    ConsultaPorId: async (cpf, id) => {
        return await apiTCEComunica.get(`/api/v1/Solicitacao/${cpf}/${id}`)
    },
    Upload: async (cpf, nome, email, telefone, files, setProgressoUploadArquivo) => {
        return await apiTCEComunica({
            method: 'post',
            url: '/api/v1/Solicitacao',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'cpf': cpf,
                'nome': encodeURIComponent(nome),
                'email': email,
                'telefone': telefone,
            },
            data: files,
            onUploadProgress: function (progressEvent) {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setProgressoUploadArquivo(prevState => ({
                    ...prevState,
                    porcentagem: percentCompleted
                }))
            }
        })
    },
    ConsultaTriagemPorSituacao: async (situacoes, pagina, qtdePagina) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/Solicitacao/triagem/pagina/' + pagina + '/qtdePagina/' + qtdePagina,
            headers: {
                'situacoes': situacoes.join()
            }
        })
    },
    DownloadArquivoBase64: async (id) => {
        return await apiTCEComunica.get(`/api/v1/Solicitacao/download/aquivo/base64/${id}`)
    },
    ConsultaOrgaoPorCnpjOuNome: async (cnpjNome) => {
        return await apiTCEComunica.get(`/api/v1/Solicitacao/orgao/cnpjNome/${cnpjNome}`)
    },
    SalvaDeferimento: async (id, idOrgao) => {
        return await apiTCEComunica.put(`/api/v1/Solicitacao/triagem/deferiacesso/solicitacao/id/${id}/orgao/idOrgao/${idOrgao}`)
    },
    UndoDeferimento: async (id) => {
        return await apiTCEComunica.put(`/api/v1/Solicitacao/triagem/deferiacesso/undo/id/${id}`)
    },
    SalvaIndeferimento: async (dto) => {
        return await apiTCEComunica.post(`/api/v1/Solicitacao/triagem/indeferiacesso/solicitacao`, dto)
    },
    UndoIndeferimento: async (id) => {
        return await apiTCEComunica.put(`/api/v1/Solicitacao/triagem/indeferiacesso/undo/id/${id}`)
    },
    ExportaCsv: async (situacoes) => {
        return await apiTCEComunica({
            method: 'get',
            url: '/api/v1/Solicitacao/triagem/exporta/csv',
            headers: {
                'situacoes': situacoes.join()
            }
        })
    },
    DownloadTermoAdesao: async () => {
        return await apiTCEComunica.get(`/api/v1/Solicitacao/download/termoadesao/base64`)
    },
}

export default SolicitacaoService 